import Competences from '@/pages/competences'
import Experiences from '@/pages/experiences'
import Hobbies from '@/pages/hobbies'

export default [
    {
        path: process.env.ROOT + '/experiences',
        name: 'xp',
        component: Experiences,
        pathToRegexpOptions: {
            strict: true
        }
    },
    {
        path: process.env.ROOT + '/hobbies',
        name: 'hobbies',
        component: Hobbies,
        pathToRegexpOptions: {
            strict: true
        }
    },
    {
        path: process.env.ROOT + '/',
        alias: '*',
        name: 'tech',
        component: Competences,
        pathToRegexpOptions: {
            strict: true
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/index.js